import React from 'react';
import { useI18n } from '@infrastructure/i18n';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Button } from '@xingternal/rebranding-adapter';
import { MEDIA_SIZES } from '@helpers/styles';
import { ErrorMessage, ErrorWrapper, Icon } from '../components/errorFragments';

export const i18nReload = {
  main: 'XTS_ERROR_TITLE',
  button: 'XTS_ERROR_CTA',
} as const;

const Message = styled(ErrorMessage)`
  font-size: ${themeGet('fontSizes.4')};
  margin-top: ${themeGet('space.4')};
  margin-bottom: ${themeGet('space.6')};

  ${MEDIA_SIZES.MEDIUM_AND_MORE} {
    font-size: ${themeGet('fontSizes.6')};
  }
`;

const ReloadBoundary = ({ resetErrorBoundary }) => {
  const { i18n } = useI18n<typeof i18nReload>();
  const main = i18n(i18nReload.main);
  const button = i18n(i18nReload.button);

  return (
    <ErrorWrapper>
      <Icon />
      <Message>{main}</Message>
      <Button variant="secondary" onClick={resetErrorBoundary}>
        {button}
      </Button>
    </ErrorWrapper>
  );
};

export { ReloadBoundary };
